import React, {Component} from 'react'

import {
    DataCell,
    DataTable,
    DataBody,
    DataHeader,
    DataRow,
    Spinner,
} from "@bdfx/mergado-ui-kit"

import {superadminGetSystemInfo} from "app/helpers/api";

import toastFactory from "app/helpers/toast_factory";
import {createToast} from "actions";

import {GENERAL_ERROR} from "template-edit/reducers";
import store from "store";

interface Props {
    selectedProjectId: number
    selectedTemplateId: number
}

export type SysInfoType = {
    memInfo: any
    loadAvg: number
    memFree: number
    swapFree: number
    diskFree: string
    diskFreePercents: number
}

interface State {
    sysInfo: SysInfoType
    isLoading: boolean
}


class SystemInfo extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            sysInfo: null,
        }
    }

    getSystemInfo = () => {
        const {selectedProjectId, selectedTemplateId} = this.props
        superadminGetSystemInfo(selectedProjectId, selectedTemplateId)
            .then((response: any) => {
                this.setState({sysInfo: response.data})
            })
            .catch(e => {
                store.dispatch(createToast(toastFactory(GENERAL_ERROR, e)))
            })
    }

    componentDidMount() {
        this.getSystemInfo()
    }

    render() {
        const {isLoading, sysInfo} = this.state

        if (isLoading) {
            return <div>
                Getting system info <Spinner type={'bubbles'} />
            </div>
        }

        if (!sysInfo) {
            return <span/>
        }

        return (
            <div>
                <h2>System info</h2>
                <DataTable onRowSelected={() => {
                }}>
                    <DataHeader>
                        <DataCell type={"header"}>CPU Load AVG</DataCell>
                        <DataCell type={"header"}>Free Mem</DataCell>
                        <DataCell type={"header"}>Free Swap</DataCell>
                        <DataCell type={"header"}>Disk Free</DataCell>
                        <DataCell/>
                    </DataHeader>
                    <DataBody>
                        <DataRow dataId={'info'}>
                            <DataCell>{sysInfo.loadAvg}</DataCell>
                            <DataCell>{sysInfo.memFree}</DataCell>
                            <DataCell>{sysInfo.swapFree}</DataCell>
                            <DataCell>{sysInfo.diskFree}</DataCell>
                            <DataCell>{sysInfo.diskFreePercents} %</DataCell>
                        </DataRow>
                    </DataBody>
                </DataTable>
            </div>
        )
    }
}

export default SystemInfo